/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";
import Header from "parts/Header";
import Footer from "parts/Footer";
import { Fade, Slide } from "react-awesome-reveal";
import Discuss from "parts/Discuss";
// eslint-disable-next-line import/no-extraneous-dependencies
import { ArrowRight } from "lucide-react"; // Adding an icon for the button

const TechnologyInfrastructurePage = () => {
  return (
    <>
      <Header />
      <div className="container min-h-screen px-6 py-12 mx-auto ">
        <Fade bottom triggerOnce>
          <h2 className="mb-6 text-5xl font-extrabold text-center text-transparent text-gray-800 bg-gradient-to-r from-teal-500 to-blue-600 bg-clip-text">
            Technology Infrastructure
          </h2>
          <p className="max-w-2xl mx-auto mb-12 text-lg text-center text-gray-600">
            All Katella Venture Capital services are supported by customized
            enterprise technology tools built by Flynn Holding Digital LLC,
            including dashboards, analytics, and secure client portals.
          </p>
        </Fade>

        <Slide direction="left" triggerOnce>
          <div className="flex flex-col max-w-5xl gap-8 mx-auto overflow-hidden transition-all duration-500 transform bg-white shadow-2xl lg:flex-row rounded-xl hover:scale-102">
            {/* Image Section */}
            <div className="flex items-center justify-center p-2 lg:w-1/2">
              <img
                src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80"
                alt="Technology Infrastructure"
                className="object-cover w-full h-64 transition-transform duration-300 lg:h-auto rounded-t-xl lg:rounded-l-xl lg:rounded-tr-none hover:scale-105"
              />
            </div>

            {/* Text Section */}
            <div className="flex flex-col justify-between p-8 lg:w-1/2">
              <div>
                <Fade bottom triggerOnce delay={200}>
                  <p className="mb-6 leading-relaxed text-gray-700">
                    Our technology infrastructure empowers clients with
                    real-time data, automated reporting, and seamless
                    collaboration. We leverage the latest digital tools to
                    ensure security, efficiency, and transparency in all our
                    services.
                  </p>
                  <ul className="space-y-4 text-gray-600">
                    <li className="flex items-center">
                      <span className="w-2 h-2 mr-3 bg-teal-500 rounded-full" />
                      Real-time dashboards for instant insights.
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 mr-3 bg-teal-500 rounded-full" />
                      Secure client portals for confidential data.
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 mr-3 bg-teal-500 rounded-full" />
                      Automated reporting to save time and effort.
                    </li>
                  </ul>
                </Fade>
              </div>
              <Fade bottom triggerOnce delay={400}>
                <button
                  type="button"
                  className="flex items-center justify-center px-6 py-3 mt-6 text-white transition-all duration-300 rounded-lg bg-gradient-to-r from-teal-500 to-blue-600 hover:from-teal-600 hover:to-blue-700"
                >
                  Explore More
                  <ArrowRight className="w-5 h-5 ml-2" />
                </button>
              </Fade>
            </div>
          </div>
        </Slide>

        <Discuss />
      </div>
      <Footer />
    </>
  );
};

export default TechnologyInfrastructurePage;
